"use client";

import { Droplet, Flame, Flashlight, Search, ShowerHead, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Management() {
  const header = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const services = [{
    code: "\n",
    title: "Structural Framing",
    description: "Precision-engineered framing solutions for residential and commercial builds, ensuring long-term structural integrity.",
    Icon: Wrench
  }, {
    code: "\n",
    title: "Property Maintenance",
    description: "Comprehensive stewardship programs designed to preserve asset value through proactive inspections and repairs.",
    Icon: ShowerHead
  }, {
    code: "\n",
    title: "Custom Renovations",
    description: "Tailored interior and exterior remodeling services that blend modern functionality with architectural character.",
    Icon: Droplet
  }, {
    code: "\n",
    title: "Site Assessment",
    description: "Detailed technical evaluations to identify potential risks and optimize project planning before ground is broken.",
    Icon: Search
  }, {
    code: "\n",
    title: "Finish Carpentry",
    description: "Expert craftsmanship in trim, molding, and custom woodwork that defines the aesthetic quality of your space.",
    Icon: Flashlight
  }, {
    code: "\n",
    title: "Project Management",
    description: "End-to-end oversight of construction workflows, ensuring timelines, budgets, and quality standards are met.",
    Icon: Flame
  }];
  return <section data-section-id="994" id="management-solutions" className="bg-background text-foreground py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={header.ref} className={`grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <p className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-6">&nbsp;]</p>
            <h2 className="font-serif font-default text-foreground leading-[1.05] tracking-tight" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)"
          }}>
              Built with precision,{" "}
              <em className="italic font-serif text-primary">managed for life.</em>
            </h2>
          </div>
          <div className="flex flex-col justify-end gap-6">
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed max-w-md">
              From foundational construction to ongoing property stewardship, Moscariello Construction delivers uncompromising quality and professional oversight for every project.
            </p>
            <Link to="/BuildingExcellencePage" className="group inline-flex items-center gap-2 font-mono text-sm text-foreground hover:text-primary transition-colors w-fit">
              <span className="border-b border-foreground/30 group-hover:border-primary pb-0.5">
                Explore our services
              </span>
              <span className="transition-transform group-hover:translate-x-1">
                &rarr;
              </span>
            </Link>
          </div>
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.Icon;
          return <div key={i} data-index={i} className="group relative flex flex-col bg-card border border-border rounded-lg p-10 transition-all duration-300 hover:border-primary overflow-hidden">
                {}
                <div className="mb-10">
                  <Icon className="text-primary transition-transform duration-300 group-hover:scale-105" strokeWidth={1} style={{
                width: "64px",
                height: "64px"
              }} />
                </div>

                {}
                <p className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-4">
                  {service.code}
                </p>

                {}
                <h3 className="font-serif font-default text-2xl text-card-foreground leading-tight mb-4">
                  {service.title}
                </h3>

                {}
                <p className="font-default text-[15px] leading-relaxed text-muted-foreground mb-8">
                  {service.description}
                </p>

                {}
                <div className="mt-auto pt-6 border-t border-border">
                  <Link to="/BuildingExcellencePage" className="inline-flex items-center gap-1.5 font-mono text-xs text-primary hover:gap-2.5 transition-all">
                    <span>Learn more</span>
                    <span>&rarr;</span>
                  </Link>
                </div>

                {}
                <span className="absolute bottom-0 left-0 h-px w-0 group-hover:w-full transition-all duration-500 ease-out" style={{
              backgroundColor: "var(--secondary)"
            }} aria-hidden="true" />
              </div>;
        })}
        </div>

        {}
        <div className="mt-12 flex justify-center lg:hidden">
          <Button asChild variant="outline" size="lg" className="font-mono text-sm rounded-lg">
            <Link to="/BuildingExcellencePage">View all services &rarr;</Link>
          </Button>
        </div>
      </div>
    </section>;
}